import { render, staticRenderFns } from "./CrossSellOfferSaleTarget.vue?vue&type=template&id=cfb65d94"
import script from "./CrossSellOfferSaleTarget.vue?vue&type=script&lang=js"
export * from "./CrossSellOfferSaleTarget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports